import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initialize() {
    $(".freight-radio").each((item) => {
      if ($($(".freight-radio")[item]).attr("checked") == "checked") {
        $($(".freight-radio")[item]).click();
      }
    });
  }
}